const PdfViewerModal = ({ isOpen, onClose, pdfUrl }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50 p-4 sm:p-8 transition-opacity duration-300 ease-in-out">
      <div className="bg-gray-100 rounded-lg shadow-2xl w-full max-w-4xl h-[90vh] flex flex-col overflow-hidden">
        <div className="flex justify-between items-center p-3 sm:p-4 border-b bg-white">
          <h3 className="text-lg sm:text-xl font-semibold text-gray-800 truncate pr-2">Spec Sheet Viewer</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors p-1 rounded-full hover:bg-gray-200"
            aria-label="Close modal"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="flex-grow bg-gray-200">
          {pdfUrl ? (
            <iframe src={pdfUrl} title="Spec Sheet PDF Viewer" width="100%" height="100%" className="border-0" />
          ) : (
            <div className="flex items-center justify-center h-full">
              <p className="text-center p-8 text-gray-500">
                No PDF URL provided or PDF could not be loaded.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PdfViewerModal;
